export interface LosAuthModel {
    id: string;
    username: string;
    userdomain: string;
    name: string;
    lastname: string;
    skin: string;
    person: string;
    user_applications: string;
    role: string[];
    salas: string[];
    sala_default_id: string;
    iss: string;
    aud: string;
    exp: number;
    nbf: number;
}